/**
 * Escapes special characters in a string to their corresponding HTML entities.
 *
 * @param {string} string - The input string to escape.
 * @returns {string} The escaped HTML string.
 */
export function escapeHtml(string) {
    return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}
